import { MENU_DURATION } from "../_defs";

const div = document.createElement("div");

Object.assign(div.style, {
  position: "absolute",
  left: "-200px",
  top: "-200px",
  width: "100px",
  height: "100px",
  overflow: "scroll",
  pointerEvents: "none",
  visibility: "hidden"
});
document.body.appendChild(div);

export const setupCssValue = (): void => {
  const html = document.documentElement;

  const update = (): void => {
    html.style.setProperty("--width", `${html.offsetWidth}`);
    html.style.setProperty("--height", `${html.clientHeight}`);
    html.style.setProperty(
      "--scrollbar-width",
      `${div.offsetWidth - div.scrollWidth}px`
    );
    html.style.setProperty("--menu-duration", `${MENU_DURATION}s`);
  };

  document.addEventListener("DOMContentLoaded", update);
  window.addEventListener("load", update);
  window.addEventListener("resize", update);
  update();
};
